var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocRecentlyAcknowledgedFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.34 20l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L23 14.34zM12 17a6.992 6.992 0 0 1 10-6.32V4a2.006 2.006 0 0 0-2-2H4a2.006 2.006 0 0 0-2 2v18l4-4h6a4.193 4.193 0 0 1 .03-.5A4.07 4.07 0 0 1 12 17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocRecentlyAcknowledgedFilled);
export default __webpack_public_path__ + "static/media/doc-recently-acknowledged-filled.3cd95aed67a8acac4076a47d978292a9.svg";
export { ForwardRef as ReactComponent };